import i18nCL from '../chile/_vue/i18nCL';

export default {
  cl: i18nCL
};
